import { render, staticRenderFns } from "./RepPersonal.vue?vue&type=template&id=768e645d&"
import script from "./RepPersonal.vue?vue&type=script&lang=js&"
export * from "./RepPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports